module.exports = __webpack_public_path__ + "static/media/demo_logo.416f7e37.png";